var map = {
	"./UL_logo-header.png": 49703,
	"./licence/by.png": 95731,
	"./licence/cc.png": 85766,
	"./preloader.gif": 88039,
	"./section_images/AkEval.jpg": 47369,
	"./section_images/DeloStud.jpg": 16419,
	"./section_images/Kazalniki.jpg": 7673,
	"./section_images/RaziskRazvoj.jpg": 28505,
	"./section_images/UL_logo-RGB_barv.png": 76468,
	"./section_images/UporabZnanj.jpg": 23361,
	"./section_images/finances.jpg": 24802,
	"./section_images/izobDejav.jpg": 97649,
	"./section_images/logoUL.jpg": 56225,
	"./section_images/logoUL1.jpg": 54688,
	"./section_images/poslo.jpg": 59962,
	"./section_images/pp_clanstvo.jpg": 99412,
	"./section_images/pp_razvojni_cilji.jpg": 91897,
	"./section_images/pp_ukrepi.jpg": 90890,
	"./section_images/qualityAssurance.jpg": 57197,
	"./section_images/umet.jpg": 16250,
	"./section_images/wp_izobrazevanje.jpg": 67149,
	"./section_images/wp_kazalniki.jpg": 28433,
	"./section_images/wp_poslovanje.jpg": 91684,
	"./section_images/wp_prenos_znanja.jpg": 34501,
	"./section_images/wp_raziskovanje.jpg": 5508,
	"./section_images/wp_sistem_kakovosti.jpg": 8078,
	"./section_images/wp_ustvarjalne_razmere.jpg": 98259,
	"./strategy/StrategijaUL_22-27.png": 72910,
	"./strategy/StrategijaUL_22-27.svg": 34358,
	"./strategy/StrategijaUL_22-27old.png": 89323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;